import {
    SETTINGS_CHANGED,
    SETTINGS_SAVE_PENDING,
    SETTINGS_SAVE_SUCCESS,
    SETTINGS_SAVE_ERROR,
    SETTINGS_VALIDATE_EMAIL_PENDING,
    SETTINGS_VALIDATE_EMAIL_SUCCESS,
    SETTINGS_VALIDATE_EMAIL_ERROR,
    SETTINGS_EMAIL_CHANGED,
    SET_LOGIN_SETTINGS
} from '../constants/ActionTypes';


const getInitialState = () => ({
    settings: {},
    isLoading: false,
    emailValidation: null,
    loginSettings: {}
});


const SettingsReducer = (state = getInitialState(), action = null) => {
    switch (action.type) {

    case SETTINGS_CHANGED:
        return {
            ...state,
            settingsBackup: state.settings,
            settings: {
                ...state.settings,
                [action.key]: action.value,
                ...computeDependentSettings(state.settings, action.key, action.value)
            }
        };

    case SETTINGS_SAVE_PENDING:
        return {...state, isLoading: true};

    case SETTINGS_SAVE_SUCCESS:
        return {...state, isLoading: false};

    case SETTINGS_SAVE_ERROR:
        return {...state, isLoading: false, settings: state.settingsBackup};

    case SETTINGS_VALIDATE_EMAIL_PENDING:
        return {
            ...state,
            emailValidation: 'pending'
        };

    case SETTINGS_VALIDATE_EMAIL_SUCCESS:
        return {
            ...state,
            emailValidation: 'success'
        };

    case SETTINGS_VALIDATE_EMAIL_ERROR:
        return {
            ...state,
            emailValidation: 'error'
        };
    case SETTINGS_EMAIL_CHANGED:
        return {
            ...state,
            emailToChangeTo: action.emailToChangeTo
        };
    case SET_LOGIN_SETTINGS:
        return {
            ...state,
            loginSettings: action.payload
        };
    default:
        return state;
    }
};

const computeDependentSettings = (stateSettings, key, value) => {
    const changes = {};
    if (key === 'share-activity') {
        changes['connections-activity-email'] = value;
        changes['connections-activity'] = value;
    }
    return changes;
};

export default SettingsReducer;
